<div class="title">
  <mat-icon>campaign</mat-icon>
  Campaign
</div>
<div class="description">SELECT THE CAMPAIGNS TO FILTER BY</div>

<div class="options">
  @for (campaign of campaigns$ | async; track campaign) {
    <elements-filter-chip
      icon="campaign"
      [caption]="campaign.name"
      [selected]="isSelected(campaign)"
      (click)="isSelected(campaign) ? remove(campaign) : add(campaign)"
      [suffixIcon]="isSelected(campaign) ? 'close' : undefined"
      >
    </elements-filter-chip>
  }
</div>

<div class="actions">
  <button styles-button (click)="close.emit()">Filter</button>
  <button styles-low-button (click)="clear()">Clear</button>
</div>
